import CalendarInput from 'components/CalendarInput/CalendarInput'
import { CheckableList } from 'components/CheckableList/CheckableList'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { NavBar } from 'components/NavBar/NavBar'
import {
  createPermit,
} from 'features/operations/permitsSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { Box, Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { ISelectValue } from 'constants/globalTypes'
import { IPermitFormState } from 'types/permits.interface'
import { DEFAULT_PERMIT_FORM, zoneScopeLevels } from './permitsData'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'

export const AddPermit = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [state, setState] = useState<IPermitFormState>({ ...DEFAULT_PERMIT_FORM })

  const handleSelect = (value: ISelectValue, name: string) => {
    setState((prev) => {
      if (name === 'zoneScopeLevel') {
        return { ...prev, zoneScopes: [], zoneScopeLevel: value }
      }
      return { ...prev, [name]: value }
    })
  }

  const handleSelectHolders = (holders: ISelectValue[]) => {
    setState((prev) => ({ ...prev, holderUserIds: holders }))
  }

  const handleSelectZoneScopes = (ids: ISelectValue[]) => {
    setState((prev) => ({
      ...prev,
      zoneScopes: ids.map((id) => ({ label: id.label, value: id.value })),
    }))
  }

  const parseZones = (data: any) => {
    const zoneTypes: Record<number, string> = {
      1: 'zones',
      2: 'sections',
      3: 'blocks',
      4: 'pits',
    }
    return data[zoneTypes[state.zoneScopeLevel?.value as number]].map((i: any) => ({
      label: i.areaName,
      value: i.id,
    }))
  }

  const handleSave = async () => {
    const resp = await dispatch(createPermit(state))
    if (resp.meta.requestStatus == 'fulfilled') {
      navigate(-1)
    }

  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex>
          <H1WithBack arrow title='Add Permit' />
        </Flex>
        <Flex mt='32' gap='1rem'>
          <Flex gap='1rem' column width='100%'>
            <Container>
              <ContainerHeader>
                <TitleText weight='bold'>Identity</TitleText>
              </ContainerHeader>
              <ContainerContent>
                <Flex column gap='1rem'>

                  <HonestSelectAsyncInput
                    link='aim-operations/permit-type'
                    placeholder='Search types...'
                    name='permitType'
                    labelText='Type'
                    onChange={handleSelect}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}

                  />
                </Flex>
              </ContainerContent>
            </Container>
            <Container>
              <ContainerHeader>
                <TitleText weight='bold'>Validity</TitleText>
              </ContainerHeader>
              <ContainerContent>
                <CalendarInput
                  labelText='Valid Until'
                  defaultValue={state.expiresAt}
                  minDate={new Date()}
                  onChange={(date) => setState((prev) => ({ ...prev, expiresAt: date as Date }))}
                />
              </ContainerContent>
            </Container>
            <Container>
              <ContainerHeader>
                <TitleText weight='bold'>Scope</TitleText>
              </ContainerHeader>
              <ContainerContent>
                <Flex column gap='1rem'>
                  <HonestSelectInput
                    options={zoneScopeLevels}
                    name='zoneScopeLevel'
                    labelText='Zone Scope Level'
                    onChange={handleSelect}
                    defaultValue={state.zoneScopeLevel?.value}
                  />
                  {state.zoneScopeLevel?.value && (
                    <CheckableList
                      link='zones/areas/non-nested'
                      parserFunction={parseZones}
                      selected={state.zoneScopes}
                      onChange={handleSelectZoneScopes}
                      selectedLabelText='Selected areas'
                      selectedPlaceholder='No areas selected'
                      listMaxHeight='16rem'
                    />
                  )}
                </Flex>
              </ContainerContent>
            </Container>
          </Flex>

          <Container>
            <ContainerHeader>
              <TitleText weight='bold'>Holders</TitleText>
            </ContainerHeader>
            <ContainerContent>
              <Box width='100%'>
                <CheckableList
                  link='users/basic'
                  parserFunction={(data: any) =>
                    data.data.map((i: any) => ({
                      label: i.fullName,
                      profilePictureUrl: i.getImagePresignedUrl,
                      value: i.id,
                      id: i.accessCardId,
                      role: i.role,
                      gender: i.gender,
                      tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy,
                    }))
                  }
                  selected={state.holderUserIds}
                  onChange={handleSelectHolders}
                  selectedLabelText='Selected holders'
                  selectedPlaceholder='No holders selected'
                  listMaxHeight='16rem'
                  searchEnabled
                />
              </Box>
            </ContainerContent>
          </Container>
        </Flex>

        <PageFooter>
          <Flex gap='1rem' mt='32' justend>
            <Button onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button orange onClick={handleSave}>
              Create
            </Button>

          </Flex>
        </PageFooter>
      </PageWrapper>
    </>
  )
}
